import React, { useContext, useEffect, useReducer } from 'react'
import { Context } from '../../../context/app-context'
import Loader from 'react-loader-spinner'
const ModalRevive = React.lazy(() =>
  import('../../molecules/modal-revive/modal-revive')
)
const GenericModal = React.lazy(() =>
  import('../../templates/generic-modal/generic-modal')
)
const ModalTerms = React.lazy(() =>
  import('../../molecules/modalTerms/modalTerms')
)

const ModalLogin = React.lazy(() =>
  import('../../molecules/modalLogin/modalLogin')
)

const ModalEndGame = React.lazy(() =>
  import('../../molecules/modal-endgame/modal-endgame')
)
const ModalInstruction = React.lazy(() =>
  import('../../molecules/modal-instruction/modal-instruction')
)
 
const ModalOpinion = React.lazy(() =>
  import('../../molecules/modal-opinion/modal-opinion')
)
const ModalConfirm = React.lazy(() =>
  import('../../molecules/modal-confirm/modal-confirm')
)
const ModalConfirmExit = React.lazy(() =>
  import('../../molecules/modal-confirm-exit/modal-confirm-exit')
)
const WaitingModal = () => {
  return (
    <div>
      {' '}
      <Loader type="Oval" color="#ffffff" height={22} width={30} />
    </div>
  )
}
const INITIAL_MODAL_STATE = null
const validateModal = (currentState, action) => {
  if (action && typeof action.type === 'string') {
    const modalProps = action?.props || {}
    const modalsList = {
      terms: <ModalTerms {...modalProps} />,
      login: <ModalLogin {...modalProps} />,

      endgame: <ModalEndGame {...modalProps} />,
      instruction: <ModalInstruction {...modalProps} />,
      
      revive: <ModalRevive {...modalProps} />,
      confirm: <ModalConfirm {...modalProps} />,
      confirmexit: <ModalConfirmExit {...modalProps} />,
      opinion: <ModalOpinion {...modalProps} />,
    }

    return modalsList[action.type]
  }
  return null
}

export default function ModalViewer() {
  const [modal, setModal] = useReducer(validateModal, INITIAL_MODAL_STATE)
  const { modalActive } = useContext(Context)

  useEffect(() => {
    setModal(modalActive)
    document.body.style.overflow = !!modalActive ? 'hidden' : 'initial'

    return () => {
      document.body.style.overflow = 'initial'
      setModal(null)
    }
  }, [modalActive])
  return (
    modal && (
      <React.Suspense fallback={<WaitingModal />}>
        {' '}
        <GenericModal {...(modalActive?.wrapperProps || {})}>
          {modal}
        </GenericModal>
      </React.Suspense>
    )
  )
}
